import type { Library } from '~/elc/features/library';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { LIBRARY_API_ROOT_URL } from '../constants';

const getLibraries = (): Promise<Library[]> => FetchPromise.get(`${LIBRARY_API_ROOT_URL}`);

export const useGetLibraries = () => useQuery<Library[], JQuery.jqXHR>(['libraries'], () => getLibraries());
